import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ApplicationRootState } from "types";
import { UserStateType } from "types/user";

import { extraReducers } from "./user.extraReducers";

export const initialState: UserStateType = {
  isLoading: false,
  isBalanceLoading: false,
  profile: null,
  balance: {
    main_balance: "",
    total: "",
  },
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUser: () => initialState,
    updateChangepassword: (
      state: UserStateType,
      action: PayloadAction<string>,
    ) => {
      if (!state.profile) return;

      state.profile = {
        ...state.profile,
        withdraw_password: action.payload,
      };
    },
  },
  extraReducers,
});

export const selectProfile = (state: ApplicationRootState) =>
  state.user.profile;
export const selectProfileLoading = (state: ApplicationRootState) =>
  state.user.isLoading;
export const selectBalance = (state: ApplicationRootState) =>
  state.user.balance;
export const selectBalanceLoading = (state: ApplicationRootState) =>
  state.user.isBalanceLoading;

export const { resetUser, updateChangepassword } = userSlice.actions;

export default userSlice.reducer;
